export const settlement_type_options = [
  { label: "Zwykły", value: false },
  { label: "Akordowy", value: true },
];

export const getSettlementTypeName = (is_pieceworker) =>
  settlement_type_options.find(({ value }) => value === Boolean(is_pieceworker))
    ?.label;

export default settlement_type_options;
